
import { defineComponent, PropType } from 'vue'
import { weatherData as wd } from "../interfaces/weatherI"

export default defineComponent({
    name: "Widget",

    props: {
        cities: {
            type: Array as PropType<Array<wd>> | undefined,
            require: true,
            default: null
        }
    },

    emits: ["showWidget"],

    setup() {
        const getIconSrc = (iconCode: string) => `http://openweathermap.org/img/wn/${iconCode}@2x.png`

        return {
            getIconSrc,
        }
    }

})
